import type { TableProps } from 'antd5';
import { Link } from 'react-router-dom';

import { None, strong } from 'components/data/helpers';
import { type TLocation, type TTurbineProps } from 'components/FleetMap/types';
import i18n from 'utils/i18n';

import { SeverityContainer, StyledCircle } from './TurbinesList.Styles';

const siteRender = (location?: TLocation) => {
  if (!location) {
    return <None />;
  }
  return (
    <Link to={`/sites/${location.id}`} target="_blank" rel="noopener noreferrer">
      {location.name}
    </Link>
  );
};

const turbineRender = (name?: string, record?: TTurbineProps) => {
  if (!name || !record?.id) {
    return <None />;
  }
  return (
    <Link to={`/turbines/${record.id}`} target="_blank" rel="noopener noreferrer">
      {name}
    </Link>
  );
};

const inspectionDateRender = (value?: TTurbineProps['inspectionData']) => {
  const { id, inspectionDate } = value ?? {};
  if (!id || !inspectionDate) {
    return <None />;
  }

  return (
    <Link to={`/inspections/${id}`} target="_blank" rel="noopener noreferrer">
      {inspectionDate}
    </Link>
  );
};

const severityRender = (severity?: number) => {
  return (
    <SeverityContainer>
      {severity ? (
        <>
          <StyledCircle $severity={severity} />
          <span>{severity}</span>
        </>
      ) : (
        <None />
      )}
    </SeverityContainer>
  );
};

export const getTurbineColumns = (): TableProps<TTurbineProps>['columns'] => [
  {
    title: strong(i18n.t('table.site', 'Site')),
    dataIndex: 'location',
    key: 'location',
    ellipsis: true,
    render: siteRender,
    width: '25%',
  },
  {
    title: strong(i18n.t('table.turbine', 'Turbine')),
    dataIndex: 'name',
    key: 'name',
    ellipsis: true,
    render: turbineRender,
    width: '25%',
  },
  {
    title: strong(i18n.t('table.mostRecentInspection', 'Most Recent Inspection')),
    dataIndex: 'inspectionData',
    key: 'inspectionData',
    render: inspectionDateRender,
    width: '30%',
  },
  {
    title: strong(i18n.t('table.maxSeverity', 'Max Severity')),
    dataIndex: ['inspectionData', 'maxSeverity'],
    key: 'severity',
    render: severityRender,
    width: '20%',
  },
];
